/*
  Goloso Sano : bundle savings badge in the Essent sticky Add to cart.

  The badge shows the difference between the six components bought separately
  and the complete system, taken from snippets/bundle-savings-data.liquid.

  The cart drawer is deliberately NOT handled here. The product carries a real
  Shopify compare-at price, so the drawer renders its own native savings row
  from Shopify data; that row is styled in assets/gs-essent.css and must stay
  the single source of the drawer figure. This file only sweeps away markup
  left by earlier builds.

  Only stable data-essential-cart-element hooks are used, never generated
  Essent class names.
*/
(function () {
  "use strict";

  var cfg = window.theme && window.theme.bundleSavings;
  if (!cfg || !cfg.handle || !cfg.separateCents) return;

  var STICKY = '[data-essential-cart-element="essential-sticky-cart-container"]';
  var STICKY_CONTENT = '[data-essential-cart-element="content"]';
  var BADGE_CLASS = "gs-save-badge";

  /* Markup from earlier builds: a savings row injected into the drawer footer,
     and before that a sentence under each cart line. Neither is produced any
     more; both are swept once so a cached page cannot show a duplicate. */
  var LEGACY_DRAWER_CLASSES = ["gs-savings-card", "gs-drawer-save"];

  var isEnglish = String(cfg.locale || "").toLowerCase().indexOf("en") === 0;
  var moneyFormatter = null;

  function money(cents) {
    if (!moneyFormatter) {
      moneyFormatter = new Intl.NumberFormat(isEnglish ? "en-GB" : "it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    return "€" + moneyFormatter.format(cents / 100);
  }

  /* The Liquid translation filter escapes for HTML output, so an apostrophe
     arrives as an entity. These strings are written with textContent, so they
     are decoded once here rather than injected as markup. */
  function decodeEntities(value) {
    var holder = document.createElement("textarea");
    holder.innerHTML = String(value || "");
    return holder.value;
  }

  function label(template, amountText) {
    return decodeEntities(template).replace("__AMOUNT__", amountText);
  }

  function removeNode(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  /* ---------------- Sticky Add to cart badge ---------------- */

  /* Shown on the bundle product page only, on desktop and on mobile. */
  var stickySaving =
    cfg.pageHandle === cfg.handle && cfg.bundleCents > 0
      ? cfg.separateCents - cfg.bundleCents
      : 0;

  function syncSticky() {
    var root = document.querySelector(STICKY);
    if (!root) return;

    if (stickySaving <= 0) {
      var stale = root.querySelectorAll("." + BADGE_CLASS);
      for (var s = 0; s < stale.length; s++) removeNode(stale[s]);
      return;
    }

    var text = label(cfg.labels && cfg.labels.compact, money(stickySaving));
    var holders = root.querySelectorAll(STICKY_CONTENT);

    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      var badge = holder.querySelector(":scope > ." + BADGE_CLASS);
      if (!badge) {
        badge = document.createElement("span");
        badge.className = BADGE_CLASS;
        holder.appendChild(badge);
      }
      if (badge.textContent !== text) badge.textContent = text;
    }
  }

  /* ---------------- One time cleanup ---------------- */

  /* Runs once at init. Nothing recreates these nodes, so no drawer observer
     or per mutation work is needed. */
  function removeLegacyDrawerMarkup() {
    for (var c = 0; c < LEGACY_DRAWER_CLASSES.length; c++) {
      var stale = document.querySelectorAll("." + LEGACY_DRAWER_CLASSES[c]);
      for (var i = 0; i < stale.length; i++) removeNode(stale[i]);
    }
  }

  /* ---------------- Scheduling ---------------- */

  var pending = false;
  function sync() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncSticky();
    });
  }

  /* Essent replaces its sticky bar node on re-render, so re-apply on any
     relevant DOM change. The writer is idempotent. */
  var observer = new MutationObserver(sync);

  function init() {
    removeLegacyDrawerMarkup();
    sync();
    observer.observe(document.body, { childList: true, subtree: true });
    /* Back navigation restores the page from bfcache without re-running init. */
    window.addEventListener("pageshow", function () {
      sync();
    });
    window.addEventListener("resize", sync, { passive: true });
    window.addEventListener("orientationchange", sync, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
